import React, {useState, useEffect} from 'react'
import { Link } from 'react-router-dom'

export default function TopNotice() {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
      const handleScroll = () => {
          if (window.scrollY > 50) {
              setScrolled(true);
          } else {
              setScrolled(false);
          }
      };
      window.addEventListener("scroll", handleScroll);
      return () => {
          window.removeEventListener("scroll", handleScroll);
      };
  }, []);
  return (
    <>
        <div id="topbar" className={`d-none d-lg-flex align-items-center fixed-top ${scrolled ? 'topbar-scrolled' : ''}`}>
          <div className="container d-flex">
            <div className="contact-info me-auto">
              <i className="bi bi-envelope-fill"></i> <Link to="mailto:rayaninfosolutions@gmail.com">rayaninfosolutions@gmail.com</Link>
              <i className="bi bi-telephone-fill"></i> <Link to="tel:+919670796799">+91 96707 96799</Link>
            </div>
            <div className="social-links">
              <Link to="https://www.facebook.com/share/1ExYswUqfz" className="facebook"><i className="bi bi-facebook"></i></Link>
              <Link to="https://www.youtube.com/channel/UCchQWaHjSJYVnfrRzOMoX4Q" className="youtube"><i className="bi bi-youtube"></i></Link>
              <Link to="https://wa.me/+919670796799" className="whatsapp"><i className="bi bi-whatsapp"></i></Link>
            </div>
          </div>
        </div>
    </>
  )
}
